import {OrgItem} from './orgItem.model';

export class OrgMapping {
    public orgMappingIndex: number;
    public isClicked: boolean;
    public isDeleting: boolean;
    public delete: boolean;
    public duplicateSchool: OrgMappingDuplicateSchool;

    constructor(
        public edutone: OrgItem = null,
        public source: OrgItem = null,
        public target: OrgItem = null,
        public customOrgName: string = null,
        public enabled: boolean = true,
        public existing: boolean = false,
        public createNewOrg: boolean = false
    ) { }
}

export class OrgMappingDuplicateSchool {
    constructor(
        public firstSourceSchoolName: string, // get school to sort by this value
        public oneRosterIdentifier: string,
        public isSourcedIdDuplicated: boolean,
        public isOneRosterIdentifierDuplicated: boolean
    ) {
    }
}

export class OrgMappingNode extends OrgMapping {
    public children: OrgMappingNode[] = [];
    public initialChildren: OrgMappingNode[] = [];
    public parent: OrgMappingNode;
    public orgMappingIndex: number;
    public isDeleting: boolean;
    public isExpanded: boolean;
    public disabled: boolean;

    constructor(
        public edutone: OrgItem = null,
        public source: OrgItem = null,
        public target: OrgItem = null,
        public customOrgName: string = null,
        public enabled: boolean = true,
        public existing: boolean = false,
        public createNewOrg: boolean = false
    ) {
        super(edutone, source, target, customOrgName, enabled, existing, createNewOrg);
    }
}

/** Flat node with expandable and level information */
export interface OrgMappingFlatNode {
    edutone: OrgItem;
    source: OrgItem;
    target: OrgItem;
    customOrgName: string;
    enabled: boolean;
    existing: boolean;
    createNewOrg: boolean;

    children: OrgMappingNode[];
    initialChildren: OrgMappingNode[];
    parent: OrgMappingNode;
    expandable: boolean;
    isExpanded: boolean;
    name: string;
    identifier: string;
    parentId: string;
    orgMappingIndex: number;
    isDeleting: boolean;
    level: number;
}

export const BLACKBOARD_ROOT = 'Blackboard root';
export const BLACKBOARD_NODES = 'Blackboard nodes';
